import { Component } from '@angular/core';
import { AbstractFieldDirective } from '../abstract-field.directive';

@Component({
  selector: 'app-generic-field',
  templateUrl: './generic-field.component.html',
  styleUrls: ['./generic-field.component.scss']
})
export class GenericFieldComponent extends AbstractFieldDirective {

  protected get type(): string {
    return this.field?.type ?? '';
  }

}
